import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import ObjectViewer from '../Common/ObjectViewer';
import { parseJSON } from '../../utils/helpers';
import RetryBarChart from './RetryBarChart';

const RetryRules = () => {
  const dispatch = useDispatch();
  const { retryRules, loadingRetryRules } = useSelector((state) => state.general);

  const [formData, setFormData] = useState({ page: 0, size: 100, filter: { status: 'PENDING' } });
  const [showChart, setShowChart] = useState(false);

  const fetchRetryRules = (formData) => {
    const { size, page, filter } = formData;
    dispatch(generalSet({ reduxField: 'loadingRetryRules', value: true }));
    dispatch(
      apiAction({
        reduxField: 'retryRules',
        route: 'retryRules/getRetryRules',
        page,
        size,
        filter,
        setLoading: 'loadingRetryRules',
      })
    );
  };

  useEffect(() => {
    fetchRetryRules(formData);
  }, []);

  console.log({ retryRules, formData });

  const statuses = ['PENDING', 'SUCCESS', 'FAILED'];
  const actionTypes = [
    'CHANGE_BUDGET',
    'CHANGE_BID_AMOUNT',
    'CHANGE_STATUS',
    'DUPLICATE_CAMPAIGN',
    'DUPLICATE_DIFF_ACCOUNT',
  ];
  return Array.isArray(retryRules?.retryRules) ? (
    <div>
      <div className='d-flex justify-content-center mt-4 border-bottom'>
        <h1>Retry Rules</h1>
      </div>
      <div className='d-flex justify-content-center mt-4 mb-2'>
        <div className='col-md-3 border p-2'>
          <h6>Status</h6>
          <select
            defaultValue={'PENDING'}
            onChange={(e) => {
              const newFormDate = { ...formData, filter: { ...formData.filter, status: e.target.value } };
              if (e.target.value === 'ALL') {
                delete newFormDate.filter.status;
              }
              setFormData(newFormDate);
              fetchRetryRules(newFormDate);
            }}
            className='form-control'
          >
            <option value='ALL' key='All'>
              All
            </option>

            {statuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div className='col-md-3 border p-2'>
          <h6>Action Type</h6>
          <select
            onChange={(e) => {
              const newFormDate = { ...formData, filter: { ...formData.filter, actionType: e.target.value } };
              if (e.target.value === 'ALL') {
                delete newFormDate.filter.actionType;
              }
              setFormData(newFormDate);
              fetchRetryRules(newFormDate);
            }}
            className='form-control'
          >
            <option value='ALL' key='All'>
              All
            </option>

            {actionTypes.map((actionType) => (
              <option key={actionType} value={actionType}>
                {actionType}
              </option>
            ))}
          </select>
        </div>

        <div className='col-md-3 border p-2'>
          <h6>Rule ID</h6>
          <div className='d-flex justify-content-between'>
            <input
              type='text'
              className='form-control'
              defaultValue={formData.filter?.ruleId || ''}
              onChange={(e) => {
                const newFormData = { ...formData, filter: { ...formData.filter, ruleId: e.target.value } };
                if (!e.target.value) {
                  delete newFormData.filter.ruleId;
                }
                setFormData(newFormData);
              }}
            />
            <button className='btn btn-outline-dark' onClick={() => fetchRetryRules(formData)}>
              <i className='fas fa-search'></i>
            </button>
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-center mt-2 mb-2'>
        <button className='btn btn-outline-dark border-0' onClick={() => setShowChart(!showChart)}>
          {showChart ? 'Hide' : 'Show'} Chart
        </button>
      </div>
      {showChart ? (
        <div className='d-flex justify-content-center mt-2 mb-2'>
          <div className='col-md-6'>
            <RetryBarChart retryRules={retryRules.retryRules} />
          </div>
        </div>
      ) : null}
      <div className='d-flex justify-content-center mt-2 mb-2'>
        <button
          className='btn btn-sm btn-outline-dark border-0'
          onClick={() => {
            setFormData({ ...formData, page: formData.page - 1 });
            fetchRetryRules({ ...formData, page: formData.page - 1 });
          }}
          disabled={formData.page === 0}
        >
          <i className='fa fa-arrow-left' aria-hidden='true'></i>
        </button>
        <button className='btn btn-sm btn-outline-dark border-0 disabled'>
          <span style={{ color: 'black' }}>
            {retryRules.page * retryRules.size + 1}-{retryRules.page * retryRules.size + retryRules.retryRules.length}{' '}
            of {retryRules.totalCount}
          </span>
        </button>
        <button
          className='btn btn-sm btn-outline-dark border-0'
          onClick={() => {
            setFormData({ ...formData, page: formData.page + 1 });
            fetchRetryRules({ ...formData, page: formData.page + 1 });
          }}
          disabled={retryRules.retryRules.length < retryRules.size}
        >
          <i className='fa fa-arrow-right' aria-hidden='true'></i>
        </button>
      </div>

      {loadingRetryRules ? (
        <>
          <div className='d-flex justify-content-center mt-4'>
            <Spinner />
          </div>
        </>
      ) : (
        <>
          <div className='mt-2'>
            {retryRules.retryRules.map((retryRule) => {
              const retryRows = parseJSON(retryRule.retryRows) || [];
              const fulfilled = Array.isArray(retryRows)
                ? retryRows?.filter((row) => row.isFulfilled === true).length
                : 0;
              const unfulfilled = retryRows.length - fulfilled;
              const data = { ...retryRule, retryRows, fulfilled, unfulfilled };
              return (
                <div key={retryRule._id} className='border p-2 mb-3'>
                  <ObjectViewer data={data} />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  ) : (
    <Spinner />
  );
};

export default RetryRules;
